const acs_showLoading = () => {
  const loading = document.querySelector('[data-load-more-products]');
  if (loading) loading.style.display = 'block';
};

const acs_hideLoading = () => {
  const loading = document.querySelector('[data-load-more-products]');
  if (loading) loading.style.display = 'none';
};

const filtersAndSortBtn = () => {
  const filterBtn = document.querySelector('[data-filters-mob-btn]');
  const filtersSlider = document.querySelector('[data-filters-and-sort-slide]');
  const closeFiltersBtn = document.querySelector('[data-close-filters-btn]');
  const applyFiltersContainer = document.querySelector('[data-current-filters-container]');
  filterBtn?.addEventListener('click', () => {
    filtersSlider.classList.add('open');
    document.body.classList.add('overflow-hidden');
  });

  closeFiltersBtn?.addEventListener('click', () => {
    filtersSlider.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
  });
};

const quickAdd = () => {
  const productCards = document.querySelectorAll('[data-product-card]');
  if (!productCards) return;
  productCards.forEach(productCard => {
    const quickAddBtn = productCard.querySelector('[data-quick-add]');
    const productVariantHover = productCard.querySelector('[data-open-product-variants]');
    const variantUnderlayer = productCard.querySelector('[data-close-product-variants]');

    quickAddBtn?.addEventListener('click', () => {
      productVariantHover.style.top = `calc(100% - ${productVariantHover.offsetHeight}px)`;
      productVariantHover.classList.add('open');
      document.body.classList.add('overflow-hidden');
    });

    variantUnderlayer?.addEventListener('click', () => {
      productVariantHover.style.top = '100%';
      productVariantHover.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
    });
  });
};

const variantsHoverHeight = () => {
  const productCards = document.querySelectorAll('[cl-product-card]');
  if (!productCards || window.innerWidth < 1024) return;
  productCards.forEach(productCard => {
    const productVariantHover = productCard.querySelector('[data-open-product-variants]');
    if (!productVariantHover) return;
    productCard.addEventListener('mouseover', () => {
      productVariantHover.style.top = `calc(100% - ${productVariantHover.offsetHeight}px)`;
    });
    productCard.addEventListener('mouseleave', () => {
      productVariantHover.style.top = '100%';
    });
  });
};

const quickAddVariantToCart = () => {
  const productCards = document.querySelectorAll('[data-product-card]');
  if (!productCards) return;
  productCards.forEach(productCard => {
    const productVariantHover = productCard.querySelector('[data-open-product-variants]');
    const addVariantBtn = productCard.querySelector('[data-add-variant-to-cart]');
    const variants = productCard.querySelectorAll('[data-product-variant-id');

    variants.forEach(variant => {
      variant.addEventListener('click', () => {
        if (productCard.querySelector('.active')) productCard.querySelector('.active').classList.remove('active');
        if (variant && variant.classList.contains('out-of-stock')) {
          addVariantBtn.innerHTML = addVariantBtn.getAttribute('data-oos-text');
          addVariantBtn.setAttribute('disabled', true);
          return;
        }
        variant.classList.add('active');
        addVariantBtn.innerHTML = addVariantBtn.getAttribute('data-in-stock-text');
        addVariantBtn.setAttribute('data-product-id', variant.getAttribute('data-product-variant-id'));
        addVariantBtn.removeAttribute('disabled');
      });
    });

    addVariantBtn.addEventListener('click', () => {
      const productPayload = [{ id: addVariantBtn.getAttribute('data-product-id'), quantity: 1 }];
      window['blubolt'].cart.addToCart(productPayload, true, () => {
        addVariantBtn.innerHTML = addVariantBtn.getAttribute('data-success-text');
        productVariantHover.classList.remove('active');
        productVariantHover.style.top = '100%';
        document.body.classList.remove('overflow-hidden');
      });
    });
  });
};

// WIP but based on current limitation with Advanced Commerce
// add in a modification to the pricing to update to be -60%
// thus mirroring their "one" b2b pricelist also -60%
const b2bPricing = () => {
  const productCards = document.querySelectorAll('[cl-product-card]');
  if (!productCards) return;
  productCards.forEach(productCard => {
    const productPrice = productCard.querySelector('.cl-product-card__price').innerText;
    const priceFloat = parseFloat(productPrice.trim().slice(1));
    // -60% off of core pricing
    const b2bPrice = (priceFloat * 0.4).toFixed(2);
    // move to formatMoney ?
    productCard.querySelector('.cl-product-card__price').innerText = window.theme.moneyFormat.replace(
      '{{amount}}',
      b2bPrice
    );
    productCard.querySelector('.cl-product-card__price').classList.remove('sale-price');
  });
};

const viewSlider = () => {
  const list = document.querySelector('[data-products-container]');
  const sliders = document.querySelectorAll('[data-view-slider]');

  if (!sliders && !list) return;

  if (window.innerWidth > 768) {
    list.className = 'view-4';
  }

  sliders.forEach(slider => {
    slider.addEventListener('change', e => {
      list.className = `view-${e.target.value}`;
    });
  });
};

const viewSliderBtns = () => {
  const gridBtn = document.querySelector('[data-slider-btn-grid]');
  const squareBtn = document.querySelector('[data-slider-btn-square]');
  const sliders = document.querySelectorAll('[data-view-slider]');
  const list = document.querySelector('[data-products-container]');

  if (!gridBtn && !squareBtn && !sliders && !list) return;

  gridBtn?.addEventListener('click', () => {
    gridBtn.style.opacity = '1';
    squareBtn.style.opacity = '0.5';
    sliders.forEach(slider => {
      slider.value = slider.max;
      list.className = `view-${slider.max}`;
    });
  });

  squareBtn?.addEventListener('click', () => {
    gridBtn.style.opacity = '0.5';
    squareBtn.style.opacity = '1';
    if (window.innerWidth > 768) {
      sliders[0].value = sliders[0].min;
      list.className = `view-${sliders[0].min}`;
    } else {
      sliders[1].value = sliders[1].min;
      list.className = `view-${sliders[1].min}`;
    }
  });
};

const sortFilter = () => {
  const sortFilters = document.querySelectorAll('[data-sort-block]');
  const url = new URL(window.location.href);
  const sort = url.searchParams.get('sort');

  sortFilters.forEach(sortFilter => {
    const sortValue = sortFilter.querySelector('input').getAttribute('data-filter-id');
    if (sort === sortValue) {
      sortFilter.classList.add('active');
    }

    sortFilter.addEventListener('click', e => {
      if (document.querySelector('[data-sort-block].active')) {
        document.querySelector('[data-sort-block].active')?.classList.remove('active');
      }
    });
  });
};

const toggleFilterInputs = () => {
  const url = new URL(window.location.href.split('?')[0]);
  const applyBtn = document.querySelector('[data-filter-apply-btn]');
  const clearBtn = document.querySelector('[data-filter-clear-btn]');
  const facetBlocks = document.querySelectorAll('[data-facet-block]');
  // const typeBlocks = document.querySelectorAll('[data-type-block]');

  clearBtn?.addEventListener('click', () => {
    const currentParams = new URLSearchParams(window.location.search);
    let params = new URLSearchParams();
    document.body.classList.remove('overflow-hidden');
    if (currentParams.has('q')) {
      params.set('q', currentParams.get('q'));
      clearBtn.href = url + '?' + params.toString();
    } else {
      clearBtn.href = url;
    }
  });

  applyBtn?.addEventListener('click', () => {
    const facetPriceRange = document.querySelector('[data-price-range] input#event-receiver.moved');
    const facetBlocksActive = document.querySelectorAll('.active[data-facet-block] input');
    const currentParams = new URLSearchParams(window.location.search);
    let params = new URLSearchParams();
    if (currentParams.has('q')) {
      params.set('q', currentParams.get('q'));
    }
    if (facetPriceRange?.value) {
      console.log(facetPriceRange.value);
      const [min, max] = facetPriceRange.value.split(', ');
      params.append('price', `${min}~${max}`);
    }
    facetBlocksActive.forEach(facetBlockActive => {
      params.append(facetBlockActive.getAttribute('data-filter-type'), facetBlockActive.getAttribute('data-filter-id'));
    });
    window.location.href = Array.from(params.values()).length > 0 ? url + '?' + params.toString() : url;
  });

  facetBlocks.forEach(facetBlock => {
    const filterInput = facetBlock.querySelector('[data-filter-input]');
    const rangeActive = document.querySelector('[data-price-range]');
    rangeActive.addEventListener('change', () => {
      totalFilters();
    });

    filterInput.addEventListener('change', () => {
      facetBlock.classList.toggle('active');
      totalFilters();
    });
  });

  // typeBlocks.forEach(typeBlock => {
  //   typeBlock.addEventListener('click', () => {
  //     if (document.querySelector('[data-type-block].active')) {
  //       document.querySelector('[data-type-block].active')?.classList.remove('active');
  //     }
  //   })
  // })
};

const totalFilters = () => {
  const filtersMobBtn = document.querySelector('[data-filters-mob-btn-value]');
  const filtersBtn = document.querySelector('[data-filters-btn-value]');
  const currentFiltersContainer = document.querySelector('[data-current-filters-container]');
  let activeFilters = document.querySelectorAll('[data-facet-block].active').length;
  activeFilters += document.querySelectorAll('[data-price-range] .moved').length;

  if (!filtersBtn || !filtersMobBtn) return;

  currentFiltersContainer.classList.remove('hide');
  // if (activeFilters >= 1) {
  // }

  filtersBtn.innerHTML = `(${activeFilters})`;
  filtersMobBtn.innerHTML = `(${activeFilters})`;
};

let pageLoading = false;

const grapheneLoadMore = () => {
  if (pageLoading) return;

  pageLoading = true;
  let nextPage = 2;
  const currentPages = document.querySelectorAll(`[data-page]`);
  currentPages.forEach(currentPage => {
    nextPage = parseInt(currentPage.dataset.page) + 1;
  });

  graphenehc.load_page({
    page_number: nextPage,
    set_page_url: true,
    init: function () {
      acs_showLoading();
    },
    success: function (response) {
      let template = response.templates.category || response.templates.search;
      const container = document.getElementById('acs_ProductList');

      // number of current visible products
      if (template.current_page > template.page_count) {
        acs_hideLoading();
        return;
      }
      container.innerHTML += template.html;
      nextPage++;
      pageLoading = false;
      scrollerInitialised = false;
      quickAdd();
      sortFilter();
      filtersAndSortBtn();
      variantsHoverHeight();
      quickAddVariantToCart();
    }
  });
};

let scrollerInitialised = false;

const grapheneObserver = () => {
  pageLoading = false;
  scrollerInitialised = false;
  if (scrollerInitialised) return;

  scrollerInitialised = true;
  document.addEventListener('scroll', () => {
    if (pageLoading) {
      return;
    }
    const screenHeight = window.innerHeight;
    const currentPage = document.querySelector(`[data-load-more-products]`);
    const getBoundRect = currentPage.getBoundingClientRect();
    const getBoundRectY = getBoundRect.y;
    if (getBoundRectY <= screenHeight) {
      grapheneLoadMore();
    }
  });
};
